import script from "./FenPai.vue?vue&type=script&setup=true&lang=js"
export * from "./FenPai.vue?vue&type=script&setup=true&lang=js"

import "./FenPai.vue?vue&type=style&index=0&id=3743d66c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3743d66c"]])

export default __exports__